// cleanup_convert_to_typescript_file_GENERICS
// cleanup_move_styles_to_new_file_GENERICS
// cleanup_hoc_to_hooks_GENERICS

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, withTheme } from '@glu/theming';
import { XCircleSolidIcon, CheckmarkCircleSolidIcon } from '@glu/icons-react';

import classnames from 'classnames';
import TextColor from 'components/textColor/TextColor';

/* istanbul ignore next */
const styles = ({ palette = {} }) => ({
  icon: {
    display: 'inline-block',
    margin: '0 3px'
  },
  error: {
    '& > svg': {
      fill: palette.error
    }
  },
  success: {
    '& > svg': {
      fill: palette.success.contrastText
    }
  }
});

export function CriteriaComponent({
  children,
  classes: { error, icon, success },
  dataQa,
  passing
}) {
  const textStyle = passing ? 'success' : 'error';
  const IconComponent = passing ? CheckmarkCircleSolidIcon : XCircleSolidIcon;

  return (
    <TextColor dataQa={`${dataQa}-${textStyle}`} textStyle={textStyle}>
      <IconComponent className={classnames(icon, passing ? success : error)} />
      {children}
    </TextColor>
  );
}

CriteriaComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.func])),
    PropTypes.element,
    PropTypes.node,
    PropTypes.func
  ]),
  classes: PropTypes.shape({}),
  passing: PropTypes.bool,
  dataQa: PropTypes.string
};
CriteriaComponent.defaultProps = {
  children: [],
  classes: {},
  passing: false,
  dataQa: 'criteria'
};

const CriteriaStyled = withStyles(styles)(CriteriaComponent);

export default withTheme(CriteriaStyled);
